import { render, staticRenderFns } from "./forgotPasswordEmail.vue?vue&type=template&id=6d6911c5&scoped=true&"
import script from "./forgotPasswordEmail.vue?vue&type=script&lang=js&"
export * from "./forgotPasswordEmail.vue?vue&type=script&lang=js&"
import style0 from "./forgotPasswordEmail.vue?vue&type=style&index=0&id=6d6911c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6911c5",
  null
  
)

export default component.exports